module.exports = __webpack_public_path__ + "img/profile_sp.0b32b4d8.jpg";